export default {
    placeManage: '需求管理',
    placeOrder: '需求订单',
    placeOrderDetails: '订单详情',
    project: '项目管理',
    projectDetails: '项目详情',
    
    
    materialDemandOrderform: '需求订单',
    materialDemandOrderformOffice: '物料需求订单-办事处',
    materialDemandOrderformRegion: '物料需求订单-大区',
    materialDemandOrderformHeadquarters: '物料需求订单-总部',

    materialDemandOrderformDetails: '物料需求订单-项目详情',
    materialDemandApprovalOfficeList: '待审批办事处列表',
    materialDemandApprovalDemandList: '待审批需求单列表',

    projectManage: '项目管理',
    projectManageDetails: '项目管理-额配详情',

    
    assetLaunchManage: '投放管理',
    storeSelection: '冰柜门店圈选',
    putReceipt: '投放任务',
    putReceiptDetails: '投放详情',
    putReceiptDetailsMaterial: '详情',
    inspection: '冰柜巡检',    
    inspectionDetails: '冰柜巡检详情',
    transferReceipt: '冰柜转投',
    transferReceiptDetails: '冰柜转投详情',
    withdrawReceipt: '冰柜撤柜',
    withdrawReceiptDetails: '冰柜撤柜详情',
    lostReceipt: '冰柜丢失',
    lostReceiptDetails: '冰柜丢失详情',
    specialReport: '冰柜报备',
    specialReportDetails: '冰柜报备详情',
    exchangeReceipt: '冰柜转让',
    exchangeReceiptDetails: '冰柜转让详情',
    pendingRedemption: '冰柜待兑付清单',
    bpRedemption: '冰柜经销商兑付清单',
    budgetManage: '冰柜预算管理',

    assetAfterSalesManage: '售后管理',
    repairReceipt: '冰柜维修',
    repairReceiptDetails: '冰柜维修详情',
    scrapReceipt: '冰柜报废',
    scrapReceiptDetails: '冰柜报废详情',

    stockTakingManage: '库存管理',
    inventory: '入库管理',
    inventoryDetails: '入库详情',
    inventoryTask: '盘点任务',
    inventoryTaskDetails: '盘点任务详情',
    inventoryTracking: '冰柜盘点',
    
    inventoryMaterialAndIcehouse: '物料库存',
    inventoryMaterialDetails: '物料详情',
    inventoryIcehouseDetails: '冰柜详情',

    materialSignforRecord:"入库管理",
    materialSignforRecordDetails:"物料签收记录详情",
    materialInventoryTask:"物料盘点任务",
    materialInventoryTaskDetails:"物料盘点详情",

    masterDataManage: '主数据管理',
    partnerMaterialsManage: '冰柜经销商资料',
    suppliersManage: '供应商管理',
    materialTypeManage: '物料类型管理',
    modelsManage: '主数据',
    coolerList: '冰柜资产列表',
    configManage: '配置管理',
    materialAddress: '物料地址管理',

    shipmentManagement:"发货管理",
    materialShipmentOrderform:"物料发货单",
    materialShipmentOrderformDetails:"物料发货单详情",

    financialManage: '财务管理',
    depositManage: '冰柜担保金账户',
    depositDetails: '冰柜担保金详情',
    AssetRedemptionList: '冰柜兑付清单',

    statementManagement: '对账单管理',
    statementManage: '对账单列表',
    statementDetails: '对账单详情页',

    logs: '日志管理',
    logsLogin: '登录日志',
    logsAction: '业务日志',
    logsCooler: '资产日志',
    logsMaterial: '日志管理',
    logsMaterialCatalogue: '物料Catalogue日志',

    noticeCenter: '通知中心',
    taskCenter: '任务中心',
    paymentTracking: '执行兑付',
    performRedemptionTracking: '执行兑付明细',
}
